import styled, { css } from 'styled-components';
import { px2rem } from '../../../../stylesheets/tools';

const StyledEducationTime = styled.div`
  display: flex;
  align-items: center;
  ${props =>
    props.large
      ? css`
          gap: ${px2rem('10px')};
        `
      : css`
          gap: ${px2rem('6px')};
        `}

  .time__icon {
    ${props =>
      props.large
        ? css`
            height: ${px2rem('26px')};
            width: ${px2rem('26px')};
          `
        : css`
            height: ${px2rem('20px')};
            width: ${px2rem('20px')};
          `}
  }
  .time__tag {
    white-space: nowrap;
    margin: 0;

    ${props =>
      props.large
        ? css`
            font-size: ${px2rem('18px')};
          `
        : css`
            font-size: ${px2rem('16px')};
          `}
  }
`;

export default StyledEducationTime;
